import { render, staticRenderFns } from "./HeaderProduct.vue?vue&type=template&id=31f4a614&scoped=true&"
import script from "./HeaderProduct.vue?vue&type=script&lang=js&"
export * from "./HeaderProduct.vue?vue&type=script&lang=js&"
import style0 from "./HeaderProduct.vue?vue&type=style&index=0&id=31f4a614&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f4a614",
  null
  
)

export default component.exports